import { render, staticRenderFns } from "./Teamspeak.vue?vue&type=template&id=75b8e355&scoped=true&"
import script from "./Teamspeak.vue?vue&type=script&lang=js&"
export * from "./Teamspeak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b8e355",
  null
  
)

export default component.exports